import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, computed, inject, input, output, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatStep, MatStepper, MatStepperModule } from '@angular/material/stepper';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { isPlatformBrowser } from '@angular/common';
import { ResolutionService } from '../../../shared/resolution.service';
import { ProductCardV2Component } from '../../../shared/product-card-v2/product-card-v2.component';
import { Product } from '../../../product/product.types';

@Component({
  selector: 'app-farmbox-choosing-signup',
  imports: [
    CommonModule,
    MatButtonModule,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatRadioModule,
    ProductCardV2Component
  ],
  templateUrl: './farmbox-choosing-signup.component.html',
  styleUrl: './farmbox-choosing-signup.component.scss'
})
export class FarmboxChoosingSignupComponent implements OnInit {
  @Input() stepper!: MatStepper;
  @Output() onNextStep: EventEmitter<any> = new EventEmitter<any>();
  farmboxCardSubscription: any

  subscriptionCard: any = input();
  selectedCard: any = null;

  #resolutionService = inject(ResolutionService);
  isMobile = computed(() => this.#resolutionService.isMobile());

  outProductSelected = output<boolean>();

  outComponentReady = output<number>();

  onProductCardHover = output<number>();

  productDetails = input<Map<number, Product>>(new Map());

  constructor(@Inject(PLATFORM_ID) private platformId: any) { }

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;
  }

  selectCard(card: any) {
    this.selectedCard = card;

    if (this.farmboxCardSubscription) {
      this.outProductSelected.emit(true);
      setTimeout(() => {
        this.onNextStep.emit();
      }, 300);
    }
  }

  selectedFarmBox($event: any, product: any) {
    this.farmboxCardSubscription = $event;
    this.selectCard(product);
  }
}
